let running = false;
let ws = null;
let lineStateArray = new Array();
/*线路状态列表*/
let userStateArray = new Array();
/*用户状态列表*/
let subscribersArray = undefined;
/*用户列表*/
let subscriberGroupsArray = new Array();
/*用户部门列表*/
let deptArray = new Array();
/*部门列表*/
let pttGroupArray = new Array();
/*对讲组列表*/
let pttGroupMembersArray = new Array();
/*对讲组成员列表*/
let confArray = new Array();
/*临时会议播列表*/
let broadcastArray = new Array();
/*临时广播列表*/
let uri = global.$config.api.ws_url;
/*websocket server地址*/
let currentLine = -1;
/*当前选中线路*/
let loginUser;
/*登录用户*/
let Base64 = require('js-base64').Base64;
let CallData = {
    CallStatue: "", /*状态*/
    Callingnumber: "", /*来电号码*/
    CurrentLine: "", /*当前线路*/
    CurrentLineState: "", /*线路状态*/
    strText: "",
    isVideoCall: false,
    confInfo: ""
};
let ErrorMsg = "";
let runStap = "";
let connectCount = 0;
let LoginCount = 0;
let LoginObj = null;
let LoginState = "Logining";
let ConnectState = "Connecting";
let resutMsgdat = "";
let MemberTypelist = [{ typename: "DISP_TYPE_DISPATCHER", num: 0, remark: "调度终端" }, {
    typename: "DISP_TYPE_IPPHONE",
    num: 1,
    remark: "IP话机"
}, { typename: "DISP_TYPE_POTS", num: 2, remark: "模拟终端" }, {
    typename: "DISP_TYPE_EXTERNAL",
    num: 3,
    remark: "外部号码"
}, { typename: "DISP_TYPE_RINGGROUP", num: 4, remark: "振铃组" }, {
    typename: "DISP_TYPE_HUNTGROUP",
    num: 5,
    remark: "轮询组"
}, { typename: "DISP_TYPE_VMAIL", num: 6, remark: "语音信箱" }, {
    typename: "DISP_TYPE_CONFERENCE",
    num: 7,
    remark: "公共会议室"
}, { typename: "DISP_TYPE_TRIGGER", num: 8, remark: "触发号码" }, {
    typename: "DISP_TYPE_PTTGROUP",
    num: 9,
    remark: "对讲组号码"
}, { typename: "DISP_TYPE_UNKNOWN", num: 10, remark: "未知类型" }];


const WSAvcPlayer = require('./wsavc/http-live-player');

/*打开对讲机通讯*/
export const OpenWebsoket = (LoginSend) => {
    console.log(2222222222222);
    connectCount++;
    LoginObj = LoginSend;
    console.log("对讲机通讯OpenWebSocket", LoginSend);
    if (running) return;
    if ('WebSocket' in window) {
        ws = new WebSocket(uri);
        ws.binaryType = "arraybuffer";
        ws.onopen = () => {
            console.log("对讲机通讯", "连接已建立:" + uri);
            running = true;
            runStap = "Open";
            ConnectState = "Success";
            Login(LoginSend);
        };
        ws.onerror = function (event) {
            //ErrorMsg = event.data;
            ConnectState = "Fail";
            console.log("对讲机通讯异常" + runStap + LoginCount, event);
            if (runStap == "" && connectCount <= 5) {
                OpenWebsoket(LoginObj);
                // ConnectState = "Connecting";
            } else if (runStap == "" && connectCount > 5) {
                connectCount = 0;
                ConnectState = "Fail";
            }
            if (runStap == "Login" && LoginCount <= 5) {
                console.log("对讲机通讯登录重新登录", LoginCount);
                Login(LoginSend);
                LoginState = "Logining";
            } else if (runStap == "Login" && LoginCount > 5) {
                console.log("对讲机通讯登录失败", event);
                LoginCount = 0;
                LoginState = "Fail";
            }
        };
        ws.onmessage = (evt) => {
            connectCount = 0;
            LoginCount = 0;
            if (typeof evt.data == "string") {
                var msgdat = evt.data;
                resutMsgdat = msgdat;

                if (msgdat.indexOf("OnPhoneState") != -1) {
                    console.log("话机注册成功", loginUser);
                    LoginState = "Success";
                }
                if (msgdat.indexOf("AllSubscribers") != -1) {
                    console.log("获取所有用户成功");
                    var myobj = JSON.parse(msgdat);
                    subscribersArray = myobj.AllSubscribers;
                }
                /*获取所有用户组*/
                if (msgdat.indexOf("SubscriberGroups") != -1) {
                    console.log("获取所有用户组成功");
                    var myobj = JSON.parse(msgdat);
                    subscriberGroupsArray = myobj.SubscriberGroups;
                    deptArray = [];
                    for (var i = 0; i < subscriberGroupsArray.length; i++) {
                        var strText = "";
                        var obj = subscriberGroupsArray[i];
                        var dept = {};
                        dept.GroupName = obj.GroupName;
                        dept.GroupMembers = obj.GroupMembers;
                        dept.ParentGroup = "";
                        deptArray.push(dept);
                        getChildGroups(obj);
                    }
                }
                /*获取所有对讲组*/
                if (msgdat.indexOf("GetPttGroupList") != -1) {
                    //console.log("获取所有对讲组成功");
                    var myobj = JSON.parse(msgdat);
                    pttGroupArray = myobj.GetPttGroupList;
                }
                /*获取某个对讲组的成员*/
                if (msgdat.indexOf("GetPttGroupMembersList") != -1) {
                    //console.log("获取某个对讲组的成员");
                    var myobj = JSON.parse(msgdat);
                    pttGroupMembersArray = myobj.GetPttGroupMembersList;
                }

                /*得到所有用户的状态 或 某个用户的状态改变事件*/
                if (
                    msgdat.indexOf("GetSubscriberStatusList") != -1 ||
                    msgdat.indexOf("OnSubscriberStatusChanged") != -1
                ) {

                    var myobj = JSON.parse(msgdat);

                    var userArray = new Array();
                    if (msgdat.indexOf("OnSubscriberStatusChanged") != -1) {
                        userArray[0] = myobj.OnSubscriberStatusChanged;
                        window.dispatchEvent(new CustomEvent('OnSubscriberStatusChanged', {
                            detail: {
                                data: msgdat
                            }
                        }))

                    } else
                        userArray = myobj.GetSubscriberStatusList;

                    for (var i = 0; i < userArray.length; i++) {
                        var strText = "";
                        var obj = userArray[i];
                        var nStatus = obj.Status;
                        if (nStatus == 0) {
                            strText = obj.Number;
                            strText += " 离线";
                        } else if (nStatus == 1) {
                            strText = obj.Number;
                            strText += " 空闲";
                        } else {
                            strText = obj.Number + "=>" + obj.OppNumber;
                            if (nStatus == 2) {
                                strText += " 振铃";
                            } else if (nStatus == 3) {
                                strText += " 呼叫中";
                            } else if (nStatus == 4) {
                                strText += " 通话";
                            } else if (nStatus == 6) {
                                strText += " 保持";
                            }
                        }


                        userStateArray[obj.Number] = obj;


                    }
                    return;
                }


                var arrInfo = msgdat.split(":");
                if (arrInfo.length == 1) {
                    if (arrInfo[0] == "Logout") {
                        ConnectState = "Fail";
                        CallStatue = "话机未注册";
                        this.ws.close();
                        return;
                    }
                }
                if (arrInfo.length == 2) {
                    if (arrInfo[0] == "OnErrorMessage") {
                        ErrorMsg = arrInfo[1];
                        ws.close();
                    } else if (arrInfo[0] == "OnStartVideoPlayer") {
                        var nline = arrInfo[1];
                        StartVideoPlayer(nline);
                        CallData.isVideoCall = true;
                    } else if (arrInfo[0] == "OnPhoneLineCount") {
                        var ncount = parseInt(arrInfo[1]);
                        for (i = 0; i < ncount; i++) {
                            var lineState = {};
                            lineState.OppNumber = "";
                            lineState.Status = 0;
                            lineStateArray[i] = lineState;
                        }
                    } else if (arrInfo[0] == "OnPhoneLineState") {
                        var strText;
                        /*数据格式: szNumber,nLine,nState,nMediaTyp  对端号码，线路号, 状态,媒体类型*/
                        var arrState = arrInfo[1].split(",");
                        var nLine = parseInt(arrState[1]);
                        var szNumber = arrState[0];
                        var nStatus = parseInt(arrState[2]);
                        var nMediaTyp = arrState[3];
                        var lineState = {};
                        lineState.OppNumber = szNumber;
                        lineState.Status = nStatus;
                        lineStateArray[nLine] = lineState;
                        CallData.isVideoCall = false;
                        if (nStatus == 0) {
                            CallData.Callingnumber = "";
                            CallData.CurrentLine = nLine;
                            CallData.CurrentLineState = "空闲";
                            DeleteBroadcastOrTempConfLine(nLine);
                            if (currentLine == nLine) currentLine = -1;
                            strText = "线路：" + nLine + "空闲";
                            CallData.strText = strText;
                            CallData.confInfo = ""
                        } else if (nStatus == 1) {
                            CallData.Callingnumber = szNumber;
                            CallData.CurrentLine = nLine;
                            CallData.CurrentLineState = "振铃";
                            currentLine = CallData.CurrentLine;
                            strText = "线路:" + CallData.CurrentLine + " ";
                            strText += "振铃 ";
                            strText += loginUser;
                            strText += "=>";
                            strText += szNumber;
                            CallData.strText = strText;
                        } else if (nStatus == 2) {
                            CallData.Callingnumber = szNumber;
                            CallData.CurrentLine = nLine;
                            CallData.CurrentLineState = "等待回铃";
                            currentLine = CallData.CurrentLine;
                            strText = "线路:" + CallData.CurrentLine + " ";
                            strText += "等待回铃 ";
                            strText += loginUser;
                            strText += "=>";
                            strText += szNumber;
                            CallData.strText = strText;
                        } else if (nStatus == 3) {
                            CallData.Callingnumber = szNumber;
                            CallData.CurrentLine = nLine;
                            CallData.CurrentLineState = "回铃";
                            currentLine = CallData.CurrentLine;
                            strText = "线路:" + CallData.CurrentLine + " ";
                            strText += "回铃 ";
                            strText += loginUser;
                            strText += "=>";
                            strText += szNumber;
                            CallData.strText = strText;
                        } else if (nStatus == 4) {
                            CallData.Callingnumber = szNumber;
                            CallData.CurrentLine = nLine;
                            CallData.CurrentLineState = "通话";
                            currentLine = CallData.CurrentLine;
                            strText = "线路:" + CallData.CurrentLine + " ";
                            strText += "通话 ";
                            strText += loginUser;
                            strText += "=>";
                            strText += szNumber;
                            CallData.strText = strText;
                        } else if (nStatus == 5) {
                            CallData.Callingnumber = szNumber;
                            CallData.CurrentLine = nLine;
                            CallData.CurrentLineState = "保持";
                            currentLine = CallData.CurrentLine;
                            strText = "线路:" + CallData.CurrentLine + " ";
                            strText += "保持 ";
                            strText += loginUser;
                            strText += "=>";
                            strText += szNumber;
                            CallData.strText = strText;
                        }
                    }
                }

                window.dispatchEvent(new CustomEvent('onmessageWS', {
                    detail: {
                        data: msgdat
                    }
                }))
            }

        };
        ws.onclose = () => {
            running = false;
            LoginState = "";
            //  ConnectState = "";
            ErrorMsg = "";
            lineStateArray = [];
            userStateArray = [];
            subscribersArray = [];
            subscriberGroupsArray = [];
            deptArray = [];
            pttGroupArray = [];
            pttGroupMembersArray = [];
            confArray = [];
            broadcastArray = [];


        };
    }
    return ws;
};

function Login(LoginSend) {
    console.log("登录信息", LoginSend);
    let strNumber = LoginSend.strNumber;
    loginUser = strNumber;
    let strPassword = LoginSend.strPassword;
    let strLocalIP = LoginSend.strLocalIP;
    let strServer = LoginSend.strServer;
    let strParam = strNumber + "," + strPassword + "," + strLocalIP + "," + strServer;
    let base64str = Base64.encode(strParam);
    /*base64编码*/
    let cmdText = "Login:" + base64str;
    LoginCount++;
    runStap = "Login";
    console.log("对讲机通讯登录", cmdText);
    console.log("LoginCount", LoginCount);
    ws.send(cmdText);
}

function StartVideoPlayer(line) {
    var num = Number(line) + 1;
    if (num < 3) {
        console.info(line);
        var canvas = document.getElementById('videoWin');
        var wsavc = new WSAvcPlayer(canvas, "webgl");
        wsavc.initCanvas(320, 240);
        wsavc.setCurrentLine(line);
        wsavc.connect(uri);

        // var wsavc = new WSAvcPlayer.default({useWorker:false});
        // document.getElementById('footer').appendChild(wsavc.AvcPlayer.canvas);
        // wsavc.setCurrentLine(line);
        // wsavc.connect(uri);
    }
}

function DeleteBroadcastOrTempConfLine(nline) {
    var idx = 0;
    confArray.forEach(ln => {
        if (ln == nline) {
            confArray.splice(idx, 1);
            return;
        }
        idx++;
    });
    idx = 0;
    broadcastArray.forEach(ln => {
        if (ln == nline) {
            broadcastArray.splice(idx, 1);
            return;
        }
        idx++;
    });
}

/**
 * 获取登录用户信息
 */
export const getLoginUser = function () {
    console.log("对讲通讯登录状态" + loginUser, LoginState);
    if (LoginState == "Success") {
        return loginUser;
    } else {
        return null;
    }
};

//登出
export const Logout = function () {
    if (running) {
        runStap = "Logout";
        var cmdText = "Logout";
        ws.send(cmdText);;
    }
}

/*发送获取所有用户信息的指令*/
export const SendAllSubscribers = function () {
    if (running) {
        //console.log("对讲机通讯", "获取所有用户信息");
        runStap = "GetAllSubscribers";
        var cmdText = "GetAllSubscribers";
        ws.send(cmdText);
    }
};

/*获取所有用户状态*/
export const GetAllUserState = function () {

    return userStateArray;
};

/*转换用户状态为字符串*/
export const GetSubscriberStatusString = function (subStatus) {
    var strStatus = "未知";
    switch (subStatus) {
        case 0:
            strStatus = "离线";
            break;
        case 1:
            strStatus = "空闲";
            break;
        case 2:
            strStatus = "振铃";
            break;
        case 3:
            strStatus = "正在呼叫";
            break;
        case 4:
            strStatus = "通话";
            break;
        case 5:
            strStatus = "禁话";
            break;
        case 6:
            strStatus = "保持";
            break;
    }
    return strStatus;
};

/*转换错误代码为字符串*/
export const GetErrcodeString = function (subStatus) {
    var strStatus = "";
    switch (subStatus) {
        case "0x01":
            strStatus = "用户登录失败";
            break;
        case "0x02":
            strStatus = "用户登录超时";
            break;
        case "0x05":
            strStatus = "连接服务器失败";
            break;
        case "0x06":
            strStatus = "连接服务器超时";
            break;
        case "0x07":
            strStatus = "用户已经登录到服务器";
            break;
        case "0x09":
            strStatus = "融合通讯登陆失败，暂无账号可使用";
            break;
        case "0x0C":
            strStatus = "数据包错误";
            break;
        case "0x0D":
            strStatus = "用户不存在";
            break;
        case "0x0E":
            strStatus = "非调度用户或不许登录";
            break;
        case "0x13":
            strStatus = "融合通讯登陆失败，暂无账号可使用";
            break;
        case "13":
            strStatus = "融合通讯登陆失败，暂无账号可使用";
            break;
        case "0x49":
            strStatus = "使用的线路忙";
            break;
        case "0x52":
            strStatus = "线路未保持";
            break;
        case "0x6D":
            strStatus = "MDVS连接失败";

            break;
    }
    return strStatus;
};

/*获取所有用户信息*/
export const GetAllSubscribers = function () {
    return subscribersArray;
};
/*根据用户编号获取用户名称*/
export const GetUserNameByNum = function (num) {
    var Name = "";
    subscribersArray.forEach(item => {
        if (item.Number == num) {
            Name = item.Name;
            return;
        }
    });
    return Name;
};

export const GetEnableVideoByNum = function (num) {
    var EnableVideo = false;
    subscribersArray.forEach(item => {
        if (item.Number == num) {
            EnableVideo = item.EnableVideo;
            return;
        }
    });
    return EnableVideo;
};
/*发送获取所有对用户组的指令*/
export const SendAllSubscriberGroups = function () {
    if (running) {
        //console.log("对讲机通讯", "获取所有对用户组");
        runStap = "GetAllSubscriberGroups";
        var cmdText = "GetAllSubscriberGroups";
        ws.send(cmdText);
    }
};
/*获取所有对用户组*/
export const GetAllSubscriberGroups = function () {
    return deptArray;
};
/*发送获取所有对讲组指令*/
export const SendGetPttGroupList = function () {
    if (running) {
        //console.log("对讲机通讯", "获取所有对讲组");
        runStap = "GetPttGroupList";
        var cmdText = "GetPttGroupList";
        ws.send(cmdText);
    }
};
/*获取所有对讲组*/
export const GetPttGroupList = function () {
    return pttGroupArray;
};
/*发送获取所有对讲组成员信息指令*/
export const SendGetPttGroupMembersList = function (number) {
    if (running) {
        //console.log("对讲机通讯", "获取所有对讲组成员" + number);
        runStap = "GetPttGroupMembersList";
        var cmdText = "GetPttGroupMembersList:" + number;
        ws.send(cmdText);
    }
};
/*获取所有对讲组成员信息*/
export const GetPttGroupMembersList = function () {
    return pttGroupMembersArray;
};
export const GetErrorMsg = function () {
    console.log("对讲通讯异常", ErrorMsg);

    return this.GetErrcodeString(ErrorMsg);
};
export const GetRunstate = function () {
    console.log("对讲通讯状态", runstate);
    return runstate;
};
export const GetConnectCount = function () {
    console.log("对讲通讯连接服务器次数", connectCount);
    return connectCount;
};
export const GetLoginState = function () {
    console.log("对讲通讯登录状态" + loginUser, LoginState);
    return LoginState;
};
export const GetConnectState = function () {
    console.log("对讲通讯服务器连接状态", ConnectState);
    return ConnectState;
};
export const GetMemberTypeByNum = function (num) {
    var remark = "";
    MemberTypelist.forEach(item => {
        if (item.num == num) {
            remark = item.remark;
            return;
        }
    });
    return remark;
};
/*语音呼叫*/
export const MakeCall = function (Num) {
    if (running) {
        var nline = -1;
        for (var x = 0; x < lineStateArray.length; x++) {
            if (lineStateArray[x].Status == 0) {
                nline = x;
                break;
            }
        }
        if (nline != -1) {
            currentLine = nline;
            var cmdText = "MakeCall:" + nline + "," + Num;
            ws.send(cmdText);
        }
    }
};
/*视频呼叫*/
export const MakeVideoCall = function (Num) {
    if (!Num && typeof (Num) != "undefined" && Num != 0) {
        return;
    }
    if (running) {
        var nline = -1;
        for (var x = 0; x < lineStateArray.length; x++) {
            if (lineStateArray[x].Status == 0) {
                nline = x;
                break;
            }
        }
        if (nline != -1) {
            var cmdText = "MakeVideoCall:" + nline + "," + Num;
            ws.send(cmdText);
        }
    }
};
/*获取语音呼叫的返回数据*/
export const GetCallData = function () {
    return CallData;
};
/*挂断*/
export const HangUp = function () {
    if (running) {
        if (currentLine == -1) {
            //alert("未找到挂断线路或线路已断开!");
            return;
        }
        var cmdText = "HangupCall:" + currentLine;
        ws.send(cmdText);
    }
};
/*接听*/
export const Answer = function () {
    if (running) {
        if (currentLine == -1) {
            alert("未找到接听线路或线路已断!");
            return;
        }
        if (lineStateArray[currentLine].Status == 1) {
            var cmdText = "AnswerCall:" + currentLine;
            ws.send(cmdText);
        } else {
            alert("接听线路状态不通![" + currentLine + ":" + lineStateArray[currentLine].Status + "]");
        }
    }
};
/*临时会议*/
export const Conference = function (strNumbers) {
    if (!strNumbers && typeof (strNumbers) != "undefined") {
        return;
    }
    if (running) {
        var nline = -1;
        for (var x = 0; x < lineStateArray.length; x++) {
            if (lineStateArray[x].Status == 0) {
                nline = x;
                break;
            }
        }
        if (nline != -1) {
            var timestamp = new Date().getTime();
            var tsp = Math.round(timestamp / 1000);
            var confName = "TempConf" + tsp;
            /*临时会议名称*/
            var confMemebers = loginUser + "," + strNumbers;
            /*"10026,20012,";				*/
            var confInfo = {};
            confInfo.confName = confName;
            confInfo.confMembers = confMemebers;
            confArray[nline] = confInfo;
            var cmdText = "Conference:" + nline + ":" + confName + ":" + confMemebers;
            CallData.confInfo = "临时会议:" + strNumbers;
            ws.send(cmdText);
        }
    }
};
/*获得所有线路*/
export const GetlineStateArray = function () {
    return lineStateArray;
};
export const GetResutMsgdata = function () {
    return resutMsgdat;
};

/*/获取用户组下的子组*/
function getChildGroups(parentGrp) {
    var childs = parentGrp.GroupChilds;
    if (typeof (childs) != "undefined") {
        for (var i = 0; i < childs.length; i++) {
            var obj = childs[i];
            var dept = {};
            dept.GroupName = obj.GroupName;
            dept.GroupMembers = obj.GroupMembers;
            dept.ParentGroup = parentGrp.GroupName;
            deptArray.push(dept);

            getChildGroups(obj);
        }
    }
}

export default {
    OpenWebsoket,
    getLoginUser,
    GetErrorMsg,
    GetRunstate,
    GetConnectCount,
    GetLoginState,
    GetConnectState,
    SendAllSubscribers,
    GetAllSubscribers,
    SendAllSubscriberGroups,
    GetAllSubscriberGroups,
    SendGetPttGroupList,
    GetPttGroupList,
    SendGetPttGroupMembersList,
    GetPttGroupMembersList,
    MakeCall,
    MakeVideoCall,
    GetCallData,
    HangUp,
    GetlineStateArray,
    GetResutMsgdata,
    Answer,
    Conference,
    GetMemberTypeByNum,
    GetUserNameByNum,
    GetAllUserState,
    GetSubscriberStatusString,
    GetErrcodeString,
    Logout,
    GetEnableVideoByNum
}